import PropTypes from 'prop-types';
import React from 'react';

import { linkPropTypes } from '../../../propTypes';

const propTypes = {
  bookNowCta: linkPropTypes.isRequired,
  callToBookText: PropTypes.string,
  isCallToBook: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  soldOutText: PropTypes.string,
};

const defaultProps = {
  callToBookText: '',
  isCallToBook: false,
  isSoldOut: false,
  soldOutText: '',
};

function Text(props) {
  return (
    <>
      {props.isCallToBook && !props.isSoldOut && (
        <span className="ButtonCta_callToBook">{props.callToBookText}</span>
      )}
      {props.isSoldOut && <span className="ButtonCta_soldOut">{props.soldOutText}</span>}
      {!props.isCallToBook && !props.isSoldOut && (
        <div className="ButtonCta">
          <a
            href={props.bookNowCta.url}
            className="Button Button-fill"
            rel="nofollow"
            title={props.bookNowCta.title}
          >
            <span className="Button_text">{props.bookNowCta.title}</span>
          </a>
        </div>
      )}
    </>
  );
}

Text.propTypes = propTypes;
Text.defaultProps = defaultProps;

export default Text;
